import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Pagination,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Typography,
} from '@mui/material';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAirportsRequest,
  deleteAirportRequest,
  resetAirportState,
  fetchAllAirportRequest,
} from '../../redux/Airports/actions/airportActions';
import SearchAndButtonTab from '../../component/ui/SearchAndButtonTab';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  ADD_AIRPORT,
  EDIT_AIRPORT,
  VIEW_AIRPORT,
} from '../../component/common/Routes/AppRoutes';
import { formatDateWithAmPm, getStatusClass } from '../../Style';
import '../../styles/Service.scss';
import '../../styles/App.scss';
import Loading from '../../component/ui/Loading';
import nodata from '../../assets/nodata.jpg';
import CustomButton from '../../component/ui/FormFields/Button';

const AirportList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { airportsList, airport } = useSelector((state) => state.airport || {});
  const user = useSelector((state) => state.auth.user);
  const permissions = user?.permissions;
  const {
    data = [],
    loading = false,
    error = null,
    totalRecords,
  } = airportsList;
  useEffect(() => {
    dispatch(resetAirportState());
  }, []);

  const [searchQuery, setSearchQuery] = useState('');
  const [searchColumn, setSearchColumn] = useState('name');
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(5);
  const viewListLoading = airportsList?.loading;
  const deleteLoading = airportsList?.deleteLoading;
  const [open, setOpen] = useState(false);
  const [airportToDelete, setAirportToDelete] = useState(null);
  const [selectedTab, setSelectedTab] = useState(2);
  useEffect(() => {
    dispatch(fetchAllAirportRequest());
  }, [page, rowsPerPage]);

  const handleTabChange = (event, newTab) => {
    setSelectedTab(newTab);
    setPage(1);
  };

  const filteredAirports = useMemo(() => {
    if (!searchQuery)
      return data?.filter(
        (airport) => airport.approoved_status === selectedTab
      );

    return data?.filter((airport) => {
      const tabMatch = airport.approoved_status === selectedTab;
      const searchMatch = airport[searchColumn]
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      return tabMatch && searchMatch;
    });
  }, [data, searchColumn, searchQuery, selectedTab]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    dispatch(fetchAllAirportRequest());
  };

  const handleExport = () => {
    const csvHeaders = [
      'Airport Name, Airport Short Name, Airport Type, Staff Edit Approval Status, Edit By, Status, Created Date, Approval Status',
    ];
    const csvRows = data.map((airport) =>
      [
        airport.name,
        airport.short_name,
        airport.airport_type,

        airport.staff_edited_status === null
          ? 'No Changes'
          : airport.staff_edited_status === 0
          ? 'Pending'
          : airport.staff_edited_status === 1
          ? 'Approved'
          : 'Rejected',
        airport?.airportUpdateLogs?.[0]?.Staff?.full_name || '-',
        airport.status === 1 ? 'Active' : 'Inactive',
        airport.created_at,
        airport?.approoved_status === 1
          ? 'Approved'
          : airport?.approoved_status === 2
          ? 'Pending'
          : 'Rejected',
      ].join(', ')
    );
    const csvContent = [csvHeaders, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'airports.csv');
  };

  const handleOpenPopup = (airport) => {
    setAirportToDelete(airport);
    setOpen(true);
  };

  const handleClosePopup = () => {
    setAirportToDelete(null);
    setOpen(false);
  };

  const handleConfirmDelete = () => {
    if (airportToDelete) {
      dispatch(deleteAirportRequest(airportToDelete.id));
      toast.success('Airport Deleted Successfully', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetAirportState());
          dispatch(fetchAllAirportRequest());
        },
      });
    }
    handleClosePopup();
  };

  const startIndex = (page - 1) * rowsPerPage;
  const paginatedAirports = filteredAirports.slice(
    startIndex,
    startIndex + rowsPerPage
  );

  if (viewListLoading) {
    return <Loading text='Loading Airport details...' />;
  }
  const columns = [
    { value: 'name', label: 'Airport Name' },
    { value: 'short_name', label: 'Short Name' },
    { value: 'airport_type', label: 'Airport Type' },
    // { value: "status", label: "Status" },
    // {
    //   value: "approoved_status",
    //   label: "Approval Status",
    //   options: [
    //     { value: 1, label: "Approved" },
    //     { value: 2, label: "Pending" },
    //     { value: 3, label: "Rejected" }
    //   ]
    // },
    // { value: "created_at", label: "Created Date" }
  ];
  return (
    <Box className='container'>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <SearchAndButtonTab
                title='Airports'
                columns={columns}
                searchColumn={searchColumn}
                setSearchColumn={setSearchColumn}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                handleExport={handleExport}
                routeName={ADD_AIRPORT}
                permissions={permissions}
                user={user}
                type='airports'
              />
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                sx={{ marginBottom: '30px', gap: 5 }}
              >
                <Tab
                  label='Pending'
                  value={2}
                  // disabled={pending_airport.length === 0}
                />
                <Tab label='Approved' value={1} />
                <Tab
                  label='Rejected'
                  value={3}
                  // disabled={rejected_airport.length === 0}
                />
              </Tabs>

              {loading ? (
                <Box textAlign='center' py={5}>
                  <CircularProgress />
                </Box>
              ) : error ? (
                <Box textAlign='center' py={5}>
                  <p>Error: {error}</p>
                </Box>
              ) : (
                <>
                  {filteredAirports.length > 0 ? (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Airport Name</TableCell>
                            <TableCell>Short Name</TableCell>
                            <TableCell>Type</TableCell>
                            {user?.role === 'Admin' && (
                              <TableCell>Staff Edit Approval Status</TableCell>
                            )}
                            {user?.role === 'Admin' && (
                              <TableCell>Edit By</TableCell>
                            )}
                            <TableCell>Approval Status</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Created Date</TableCell>

                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {console.log('paginatedAirports', paginatedAirports)}
                          {paginatedAirports.map((airport) => (
                            <TableRow key={airport.id}>
                              <TableCell>{airport.name}</TableCell>
                              <TableCell>{airport.short_name}</TableCell>
                              <TableCell>{airport.airport_type}</TableCell>
                              {user?.role === 'Admin' && (
                                <TableCell>
                                  <span
                                    className={`badge ${getStatusClass(
                                      airport.staff_edited_status === null
                                        ? 'No Changes'
                                        : airport.staff_edited_status === 0
                                        ? 'Pending'
                                        : airport.staff_edited_status === 1
                                        ? 'Approved'
                                        : 'Rejected'
                                    )}`}
                                  >
                                    {airport.staff_edited_status === null
                                      ? 'No Changes'
                                      : airport.staff_edited_status === 0
                                      ? 'Pending'
                                      : airport.staff_edited_status === 1
                                      ? 'Approved'
                                      : 'Rejected'}
                                  </span>
                                </TableCell>
                              )}

                              {user?.role === 'Admin' && (
                                <TableCell>
                                  {airport?.airportUpdateLogs?.[0]?.Staff
                                    ?.full_name || '-'}
                                </TableCell>
                              )}
                              <TableCell>
                                <span
                                  className={`badge ${getStatusClass(
                                    airport.approoved_status === 1
                                      ? 'Approved'
                                      : airport.approoved_status === 2
                                      ? 'Pending'
                                      : 'Rejected'
                                  )}`}
                                >
                                  {airport.approoved_status === 1
                                    ? 'Approved'
                                    : airport.approoved_status === 2
                                    ? 'Pending'
                                    : 'Rejected'}
                                </span>
                              </TableCell>

                              <TableCell>
                                <span
                                  className={`badge ${getStatusClass(
                                    airport.status === 1 ? 'Active' : 'Inactive'
                                  )}`}
                                >
                                  {airport.status === 1 ? 'Active' : 'Inactive'}
                                </span>
                              </TableCell>
                              <TableCell>
                                {formatDateWithAmPm(airport.created_at)}
                              </TableCell>

                              <TableCell>
                                <Box className='button-list'>
                                  {(permissions?.airports?.view ||
                                    user?.user_type === 1) && (
                                    <Button
                                      variant='outlined'
                                      size='small'
                                      className='view-user-button'
                                      onClick={() =>
                                        navigate(
                                          `${VIEW_AIRPORT}/${airport.id}`
                                        )
                                      }
                                    >
                                      View
                                    </Button>
                                  )}
                                  {(user?.user_type === 1 ||
                                    user?.user_type === 4) && (
                                    <Button
                                      variant='outlined'
                                      className='edit-user-button'
                                      size='small'
                                      onClick={() => {
                                        dispatch(resetAirportState());
                                        navigate(
                                          `${EDIT_AIRPORT}/${airport.id}`
                                        );
                                      }}
                                    >
                                      Edit
                                    </Button>
                                  )}
                                  {(permissions?.airports?.delete ||
                                    user?.user_type === 1) && (
                                    <Button
                                      variant='outlined'
                                      color='error'
                                      className='delete-user-button'
                                      size='small'
                                      onClick={() => handleOpenPopup(airport)}
                                    >
                                      Delete
                                    </Button>
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      {paginatedAirports.length === 0 && (
                        <img
                          src={nodata}
                          alt='nodata'
                          style={{ maxWidth: '300px', maxHeight: '300px' }}
                        />
                      )}
                    </div>
                    // <Typography
                    //   sx={{ textAlign: "center", padding: 2, color: "red" }}
                    // >
                    //   No Airport details available.
                    // </Typography>
                  )}

                  <Box className='button-box'>
                    <Pagination
                      count={Math.ceil(filteredAirports.length / rowsPerPage)}
                      page={page}
                      onChange={handlePageChange}
                      color='primary'
                    />
                  </Box>
                </>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog open={open} onClose={handleClosePopup}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete{' '}
            <strong>{airportToDelete?.name}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            size='small'
            onClick={handleClosePopup}
            className='handle-back'
          >
            Cancel
          </Button>
          <CustomButton
            variant='contained'
            className='handle-delete'
            type='button'
            size='small'
            loading={deleteLoading}
            text={'DELETE'}
            onClick={() => handleConfirmDelete()}
          />
          {/* <Button
            size='small'
            onClick={handleConfirmDelete}
            className='handle-delete'
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete'}
          </Button> */}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AirportList;
